/** @format */
import angular from 'angular';
import _ from 'lodash';
export const plainTextFilterModule = 'sis-components.string.plainTextFilter';
(function () {
  angular.module(plainTextFilterModule, []).filter('plainText', plainText);

  /**
   * @ngInject
   */
  function plainText() {
    return function (text) {
      if (_.isString(text)) {
        // from https://stackoverflow.com/a/17315483
        return text ? String(text).replace(/<[^>]+>/gm, '') : '';
      }
      return '';
    };
  }
})();